export enum BooleanEnum {
	YES = 'YES',
	NO = 'NO',
}
